import { RouteConfig } from 'vue-router'
import {requireAuth} from '../auth'
import { aiEmployeePromoRoutes } from '../constants/agency/'

const AiEmployeePromo = () =>
  import(
    /* webpackChunkName: "ai-employee-promo" */ '@/apps/conversations/settings/aiEmployeePromo.vue'
  )

export const aiEmployeePromo:RouteConfig[] = [
  // {
  //   path: 'ai-employee-promo',
  //   name: aiEmployeePromoRoutes.default,
  //   component: AiEmployeePromo,
  //   beforeEnter: requireAuth,
  // },
  // {
  //   path: 'conversation-ai',
  //   name: conversationAIRouteNames.conversationAISettings,
  //   component: ConversationAiSettings,
  //   beforeEnter: requireAuthAndLocation,
  //   children: [
  //     {
  //       path: '/',
  //       component: ConversationAiSettings,
  //       beforeEnter: requireAuthAndLocation,
  //     },
  //   ],
  // },
  {
    path: '/summer-ai',
    redirect: to => {
      return { path: '/ai-employee-promo', query: to.query }
    }
  },
  {
    path: '/ai-employee-promo',
    name: aiEmployeePromoRoutes.default,
    component: AiEmployeePromo,
    beforeEnter: requireAuth,
    // meta: { 
    //     translations: [Modules.Agency] 
    //     module: [Modules.Agency] 
    //     },
  }
]
